document.addEventListener('DOMContentLoaded', () => {
    const articlesContainer = document.getElementById('articles');
    const blogSection = document.getElementById('BlogSection');
    const paginationContainer = document.getElementById('blog-pagination');
    const categoriesContainer = document.querySelector('.blog-header__categories');

    const updateArticles = (doc) => {
        // Update Articles
        const newArticlesContainer = doc.getElementById('articles');
        if (newArticlesContainer && articlesContainer) {
            articlesContainer.innerHTML = newArticlesContainer.innerHTML;
        }

        // Update Pagination
        const newPagination = doc.getElementById('blog-pagination');
        if (newPagination && paginationContainer) {
            paginationContainer.innerHTML = newPagination.innerHTML;
        } else if (paginationContainer) {
            paginationContainer.innerHTML = '';
        }

        // Update Categories (active state)
        const newCategories = doc.querySelector('.blog-header__categories');
        if (newCategories && categoriesContainer) {
            categoriesContainer.innerHTML = newCategories.innerHTML;
        }
    };

    const handleCategoryClick = async (url) => {
        try {
            const response = await fetch(url);
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            updateArticles(doc);
            history.pushState(null, '', url);

            if (blogSection) {
                const header = document.querySelector('.section-header');
                const headerHeight = header ? header.offsetHeight : 0;
                const offset = headerHeight + 20; // Header height + small buffer

                const elementPosition = blogSection.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        } catch (error) {
            console.error('Failed to load category', error);
            window.location.href = url;
        }
    };

    const handleLoadMore = async (btn) => {
        const url = btn.getAttribute('data-url');
        if (!url) return;

        btn.disabled = true;
        const originalText = btn.textContent;
        btn.textContent = '...';

        try {
            const response = await fetch(url);
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            
            // Append new articles
            const newArticles = doc.getElementById('articles');
            if (newArticles && articlesContainer) {
                articlesContainer.innerHTML += newArticles.innerHTML;
            }

            // Update pagination (button for the next page)
            const newPagination = doc.getElementById('blog-pagination');
            if (newPagination && paginationContainer) {
                paginationContainer.innerHTML = newPagination.innerHTML;
            } else if (paginationContainer) {
                paginationContainer.innerHTML = '';
            }
        } catch (error) {
            console.error('Failed to load more articles', error);
            btn.disabled = false;
            btn.textContent = originalText;
        }
    };

    document.addEventListener('click', (e) => {
        // Handle Category/Tag clicks
        const categoryLink = e.target.closest('.blog-item__category, .article-item__category');
        if (categoryLink) {
            // Only AJAX if we are already on a blog page
            if (document.querySelector('.main-blog')) {
                e.preventDefault();
                handleCategoryClick(categoryLink.href);
            }
            return;
        }

        // Handle Load More clicks
        const loadMoreBtn = e.target.closest('.blog-grid__loadmore-btn');
        if (loadMoreBtn) {
            e.preventDefault();
            handleLoadMore(loadMoreBtn);
        }
    });

    // Handle back/forward buttons
    window.addEventListener('popstate', () => {
        window.location.reload();
    });
});